export default __webpack_public_path__ + "static/media/Version (3) - Order of the Phoenix_10.46148e24.jpg";